import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '@edx/frontend-platform/i18n';
import ExamCode from './ExamCode';

const DefaultInstructions = ({ code, providerName }) => (
  <>
    {providerName !== 'EXAMUS'
      ? (
        <div>
          <div className="h4">
            <FormattedMessage
              id="exam.DefaultDownloadSoftwareProctoredExamInstructions.step1.title"
              defaultMessage="Step 1."
            />
          </div>
          <div>
            <ExamCode code={code} />
          </div>
          <p>
            <FormattedMessage
              id="exam.DefaultDownloadSoftwareProctoredExamInstructions.step1.body"
              defaultMessage="Select the exam code, then copy it using Control + C (Windows) or Command + C (Mac)."
            />
          </p>
          <div className="h4">
            <FormattedMessage
              id="exam.DefaultDownloadSoftwareProctoredExamInstructions.step2.title"
              defaultMessage="Step 2."
            />
          </div>
          <p>
            <FormattedMessage
              id="exam.DefaultDownloadSoftwareProctoredExamInstructions.step2.body1"
              defaultMessage="Start your system check now. A new window will open for this step and you will verify your identity."
            />
          </p>
          <p>
            <FormattedMessage
              id="exam.DefaultDownloadSoftwareProctoredExamInstructions.step2.body2"
              defaultMessage="Make sure you:"
            />
          </p>
          <ul>
            <li>
              <FormattedMessage
                id="exam.DefaultDownloadSoftwareProctoredExamInstructions.step2.body3"
                defaultMessage="Have a computer with a functioning webcam"
              />
            </li>
            <li>
              <FormattedMessage
                id="exam.DefaultDownloadSoftwareProctoredExamInstructions.step2.body4"
                defaultMessage="Have your valid photo ID (e.g. driver's license or passport) ready"
              />
            </li>
          </ul>
        </div>
      )
      : (
        <ol>
          <li key={1}>
            <FormattedMessage
              id="exam.DownloadSoftwareProctoredExamInstructions.examusText1"
              defaultMessage="Click the Start Exam button to start the proctored exam."
            />
          </li>
          <li key={2}>
            <FormattedMessage
              id="exam.DownloadSoftwareProctoredExamInstructions.examusText2"
              defaultMessage="Follow the instructions in the new tab."
            />
          </li>
          <li key={3}>
            <FormattedMessage
              id="exam.DownloadSoftwareProctoredExamInstructions.examusText3"
              defaultMessage="To see and manage exams that require registration we recommend using the Pre-Scheduled Exams tab. If the scheduled exam is not yet available to start, the Start Exam button will redirect you to the Examus calendar where you can manage your registrations."
            />
          </li>
        </ol>
      )}
  </>
);

DefaultInstructions.propTypes = {
  code: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired,
};

export default DefaultInstructions;
